module.exports = __webpack_public_path__ + "media/gtm/bghead-cbde0a26.png";